import * as React from "react";
import { SVGProps } from "react";

const BitcoinSv = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2499 2500" {...props}>
    <path
      fill="#eab300"
      d="M2499.6 1250c0 690.2-559.6 1249.8-1250.1 1249.9-690 0-1249.6-559.7-1249.5-1250C-.2 559.6 559.4 0 1249.7 0s1249.9 559.7 1249.9 1250z"
    />
    <g fill="#fff">
      <path d="M1741.5 943.8c-16.1-167.4-160.6-223.5-343.2-239.5V472H1257v226.1c-37.1 0-75.1.7-112.8 1.5V472h-141.3l-.1 232.1c-30.6.6-60.7 1.2-90 1.2v-.7l-194.9-.1v151s104.4-2 102.6-.1c57.3 0 75.9 33.2 81.3 61.9v264.6c4 0 9.1.2 14.9 1h-14.9l-.1 370.7c-2.5 18-13.1 46.7-53.1 46.8 1.8 1.6-102.7 0-102.7 0l-28.1 168.8h184c34.2 0 67.9.6 100.9.8l.1 234.9H1144v-232.4c38.7.8 76.2 1.1 112.9 1.1l-.1 231.3h141.3v-234.4c237.6-13.6 404.1-73.5 424.7-296.7 16.7-179.7-67.8-260-202.7-292.4 82.1-41.6 133.4-115.1 121.4-237.6zM1543.7 1446c0 175.5-300.5 155.6-396.4 155.6v-311.3c95.9.2 396.4-27.3 396.4 155.7zm-65.8-439.1c0 159.7-250.8 141-330.6 141.1V865.8c79.9 0 330.7-25.4 330.6 141.1z" />
      <path d="M902 1175.7h21v15.5h-21z" />
    </g>
  </svg>
);

export default BitcoinSv;
